export default __webpack_public_path__ + "static/media/logo.a7165c8e.png";